<template>
    <v-dialog width="500" v-model="showtriptimeStamp">
        <v-card>
            <v-card-title class="secondary white--text">
                <span> Edit TimeStamp {{ tripDetails.trip_id }}</span>

                <v-spacer></v-spacer>

                <v-btn icon @click="resetForm(), (showtriptimeStamp = false)">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pt-2">
                <v-form ref="tripstampForm" v-if="showtriptimeStamp" v-model="isValid">
                    <v-row class="my-0">
                        <v-col cols="12" class="Form-Columns">
                            <DateField :inputProps="{
                                dense: true,
                                label: 'Actual Trip Start Date *',
                                rules: [(val) => !!val || 'Actual Trip Start Date is Required!'],
                                'hide-details': 'auto',
                            }" required v-model="tripDetails.trip_start_date" />
                        </v-col>
                        <v-col cols="12" class="Form-Columns">
                            <InputField type="time" label="Actual Trip Start Time *"
                                :rules="[(val) => !!val || 'Actual Trip Start Time is Required!']" required
                                hide-details="auto" v-model="tripDetails.trip_start_time" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="justify-end">
                <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">
                    Submit
                </v-btn>

                <v-btn class="ml-3" color="secondary" depressed @click="resetForm">
                    Reset
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import DateField from "@/components/FormBaseComponents/DateField.vue";

export default {
    components: {
        InputField,
        MultiSelect,
        DateField,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        tripID: {
            type: [Number, null],
            default: null,
        }


    },
    watch: {
        value(val) {
            if (val) {
                this.getTripDetails(this.tripID)
            } else {
                this.resetForm();
            }
        },
    },
    computed: {
        showtriptimeStamp: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {
            isValid: true,
            isTextInput: false,
            formErrors: {},
            tripDetails: {},
        };
    },
    methods: {
        submitForm() {
            this.$bus.$emit("showLoader", true);

            this.$api.trip
                .updateTriptimeSatmp({
                    id: this.tripDetails.id,
                    data: {
                        trip_start_date: this.tripDetails.trip_start_date,
                        trip_start_time: this.tripDetails.trip_start_time,
                    },
                })
                .then((res) => {
                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: "Branch updated successfully!",
                        color: "success",
                    });
                    this.resetForm();
                    this.showtriptimeStamp = false;
                    this.$emit("refreshList");
                })
                .catch((err) => {

                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: `${err.data && err.data.error
                            ? err.data.error
                            : "Couldn't update Trip"
                            }`,
                        color: "error",
                    });

                    this.formErrors = err.data;
                });

        },

        resetForm() {
            if (this.$refs.tripstampForm) {
                this.$refs.tripstampForm.reset();
            }
            this.tripDetails = {};
        },

        async getTripDetails(id) {
            try {
                this.$bus.$emit("showLoader", true);

                const res = await this.$api.trip.getTripObject(id);
                console.log(res)
                this.tripDetails = res.data;

            } catch (err) {
                console.error(err);
            } finally {
                this.$bus.$emit("showLoader", false);
            }
        }



    },

};
</script>
